import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

function OrderReceipt({retailerDetails}) {
      const { t, i18n } = useTranslation();
    
  const dummyOrder = {
    order_no: "ORD123456",
    date: "2025-06-23",
    cashier: retailerDetails?.retailer_name,
    customer: "XYZ",
    customer_mobile: "0123xxxxxx",
    order_status: "draft",
    order_ref: "",
    order_value: 200.0,
    delivery_fee: 20.0,
    return_delivery_fee: 0,
    payment_data: [
      {
        payment_method: "Cash",
        amount: 220.0,
        name: "",
      },
    ],
    products_lines: [
      {
        name: "Product A",
        qty: 2,
        price_unit: 50.0,
        sub_total: 100.0,
      },
      {
        name: "Product B",
        qty: 1,
        price_unit: 100.0,
        sub_total: 100.0,
      },
    ],
    compan_add: {
      logo:  retailerDetails?.logo,
      street: retailerDetails?.shop_address?.street,
      street2: retailerDetails?.shop_address?.street2,
      city:retailerDetails?.shop_address?.city,
      state: retailerDetails?.shop_address?.state,
      country: retailerDetails?.shop_address?.country,
      tel:retailerDetails?.mobile,
    },
    customer_address: [
      {
        name: "Villa",
        add_field_1: "10",
        add_field_2: "5",
        add_field_3: "Palm Street",
        add_field_4: "Near Mall",
      },
    ],
    pos_receipt_custom_msg: retailerDetails?.pos_receipt_custom_msg,
  };

  const Cash = dummyOrder.payment_data[0].amount;
  const Change = (Cash - dummyOrder.order_value).toFixed(2);
  const order_idChange = dummyOrder.order_no.replace(/\s/g, "%20");

  useEffect(() => {
    const handleKeyDown = (event) => {
      const container = document.querySelector(".custom-scrollbar");
      if (!container) return;
      if (event.key === "ArrowUp") container.scrollTop -= 40;
      if (event.key === "ArrowDown") container.scrollTop += 40;
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className="flex bg-white w-full h-full justify-center">
  {retailerDetails?.status == "approved" ? (

    <div className="flex flex-col text-center w-[55%] max-md:w-full h-full">
      <div className=" flex flex-col grow px-2 bg-white border border-stone-300 max-md:px-3 max-md:mt-10 max-md:max-w-full h-full w-full">
        <div className="overflow-y-auto custom-scrollbar mb-20 mt-2 px-8">
          <div className="flex justify-center">
            <img src={dummyOrder.compan_add.logo} alt="Store Logo" width="125" />
          </div>
          <div className="mt-2 font-bold">My Company Name</div>
          <div className="text-sm">
            {`${dummyOrder.compan_add.street}, ${dummyOrder.compan_add.street2}, ${dummyOrder.compan_add.city}, ${dummyOrder.compan_add.state}, ${dummyOrder.compan_add.country}`}
          </div>
          <div className="text-sm">+20 {dummyOrder.compan_add.tel}</div>

          <div className="text-lg font-bold py-2">Receipt</div>

          <div className="border-y-2 border-dashed border-black py-2">
            <div className="flex justify-between">
              <strong>Order Number:</strong> <span>{dummyOrder.order_no}</span>
            </div>
            <div className="flex justify-between">
              <strong>Order Date:</strong> <span>{dummyOrder.date}</span>
            </div>
            <div className="flex justify-between">
              <strong>Cashier Name:</strong> <span>{dummyOrder.cashier}</span>
            </div>
            <div className="flex justify-between">
              <strong>Customer Name:</strong> <span>{dummyOrder.customer}</span>
            </div>
            <div className="flex justify-between">
              <strong>Customer Phone No.:</strong> <span>{dummyOrder.customer_mobile}</span>
            </div>
            <div className="flex justify-between">
              <strong>Address:</strong>
              <span>
                {dummyOrder.customer_address.map((addr, i) => (
                  <div key={i} className="text-right">
                    Villa No.- {addr.add_field_1}, Group No.- {addr.add_field_2},
                    Street- {addr.add_field_3}, {addr.add_field_4}
                  </div>
                ))}
              </span>
            </div>
          </div>

          <table className="w-full mt-4 text-sm">
            <thead>
              <tr>
                <th className="text-center">S.N</th>
                <th className="text-center">Product Name</th>
                <th className="text-center">Qty</th>
                <th className="text-center">Unit Price</th>
                <th className="text-center">Amount</th>
              </tr>
            </thead>
            <tbody>
              {dummyOrder.products_lines.map((item, idx) => (
                <tr key={idx}>
                  <td className="text-center">{idx + 1}</td>
                  <td className="text-center">{item.name}</td>
                  <td className="text-center">{item.qty}</td>
                  <td className="text-center">{item.price_unit.toFixed(2)}</td>
                  <td className="text-center">{item.sub_total.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="border-t-2 border-dashed border-black mt-4"></div>

          <div className="flex justify-between py-2 mt-4">
            <strong>Delivery Fee</strong>
            <span>EGP {dummyOrder.delivery_fee.toFixed(2)}</span>
          </div>

          <div className="flex justify-between py-2">
            <strong>Total</strong>
            <span>EGP {dummyOrder.order_value.toFixed(2)}</span>
          </div>

          <div className="flex justify-between py-2">
            <strong>{dummyOrder.payment_data[0].payment_method}</strong>
            <span>EGP {Cash.toFixed(2)}</span>
          </div>

          <div className="flex justify-between py-2">
            <strong>Change</strong>
            <span>EGP {Change}</span>
          </div>

          <div className="w-full my-4 flex justify-center">
            <img
              src={`https://barcode.tec-it.com/barcode.ashx?data=${order_idChange}&code=Code39&translate-esc=on`}
              alt="Barcode"
              width="90%"
            />
          </div>

          <div className="text-center border-t-2 border-dashed border-black mt-10 text-lg pt-4">
            Your Technology Partner
            <br />
            <img
              src="https://images.myginne.com/myginne.webp"
              alt="myGinne Logo"
              width="150"
              className="mx-auto"
            />
          </div>

          <div className="flex justify-center mt-3 font-bold">
            {dummyOrder.pos_receipt_custom_msg}
          </div>
        </div>
      </div>
    </div> ) : <>
    <div className="flex justify-center w-full mt-16 text-base text-body text-center p-3 font-normal ">
            {retailerDetails?.status && retailerDetails?.status != 'approved' ? t(
              "You cannot update cashier settings until your store is approved by myGINNE."
            ) : ''}
          </div>
    </>}
        </div>
  );
}

export default OrderReceipt;
